import { initialState } from './initialState'

export const wlsyFetch = async (options: Request) =>
  initialState(options) || (await fetch(options))
